import { accessToken, PATRIMONUS_API_URL } from './auth.js';

async function jsonResponse(response, source) {
	if (!response.ok) {
		throw new Error(`${source} returned ${response.status}`);
	}
	return response.json();
}

export async function createAsset(name, type, location, productType) {
	const token = await accessToken();
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ name, type, location, productType })
	});

	return jsonResponse(response, 'Patrimonus API');
}

export async function updateAsset(id, name, type, location, productType) {
	const token = await accessToken();
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}`, {
		method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
		body: JSON.stringify({ name, type, location, productType })
	});
	return jsonResponse(response, 'Patrimonus API');
}

export async function getLiabilities(id) {
    const token = await accessToken();
    const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/liabilities`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return jsonResponse(response, 'Patrimonus API');
}

export async function addLiability(id, date, amount, currency) {
    const token = await accessToken();
    const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/liabilities`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, amount, currency })
    });
    return jsonResponse(response, 'Patrimonus API');
}

export async function getValuations(id) {
    const token = await accessToken();
    const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/valuations`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return jsonResponse(response, 'Patrimonus API');
}

export async function addValuation(id, date, amount, currency) {
    const token = await accessToken();
    const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/valuations`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, amount, currency })
    });
    return jsonResponse(response, 'Patrimonus API');
}

async function updateDatedRecord(assetId, kind, recordId, date, amount, currency) {
    const token = await accessToken();
    const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${assetId}/${kind}/${recordId}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, amount, currency })
    });
    return jsonResponse(response, 'Patrimonus API');
}

export const updateValuation = (assetId, recordId, date, amount, currency) => updateDatedRecord(assetId, 'valuations', recordId, date, amount, currency);
export const updateLiability = (assetId, recordId, date, amount, currency) => updateDatedRecord(assetId, 'liabilities', recordId, date, amount, currency);

export async function getOwnerships(id) {
    const token = await accessToken();
    return jsonResponse(await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/ownerships`, {
        headers: { Authorization: `Bearer ${token}` }
    }), 'Patrimonus API');
}

export async function saveOwnerships(id, owners) {
    const token = await accessToken();
    return jsonResponse(await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}/ownerships`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ owners })
    }), 'Patrimonus API');
}

export async function deleteAsset(id, name) {
	const token = await accessToken();
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ name }) });
	if (!response.ok) throw new Error(`Patrimonus API returned ${response.status}`);
}

export async function getAssets() {
	const token = await accessToken();
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/assets`, {
		headers: {
			Authorization: `Bearer ${token}`
		}
	});

	return jsonResponse(response, 'Patrimonus API');
}

export async function deleteProfile(name) {
	const token = await accessToken();
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/profile`, {
		method: 'DELETE',
		headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
		body: JSON.stringify({ name })
	});
	if (!response.ok) {
		throw new Error(`Patrimonus API returned ${response.status}`);
	}
}

export async function getApiBuildInfo() {
	const response = await fetch(`${PATRIMONUS_API_URL}/ui/build-info`, {
		cache: 'no-store'
	});
	return jsonResponse(response, 'Patrimonus API');
}

export async function getWebBuildInfo() {
	const response = await fetch('/build-info.json', {
		cache: 'no-store'
	});
	return jsonResponse(response, 'Patrimonus Web');
}
